<template>
  <div class="data-pages dataList">
    <div class="p16">
      <p style="font-weight: bold;">积分业绩<span class="moneys fontSize14">（数据指标可能存在几分钟延迟）</span></p>
    </div>
    <div class="page-head">
      <div class="mains-content">
        <div class="member-content-box">
          <div class="boxs mb10 br10">
            <div class="titles">
              <p class="order-title-boxs mtb20"><span class="blueBlock"></span><i>业绩汇总</i></p>
              <v-date @time="change" class="ml10"></v-date>
              <el-select v-model="query.staffId" @change="selectChange" class="select ml10" placeholder="全部店员">
                <el-option v-for="(item,index) in staffList" :key="index" :label="item.staffName" :value="item.id"></el-option>
              </el-select>
            </div>
            <el-row class="rows">
              <el-col class="cols" :span="4">
                <p class="van-text">劳动业绩</p>
                <p class="van-label">{{ amount.workAchieveAmount }}</p>
              </el-col>
              <el-col class="cols" :span="4">
                <p class="van-text">销售业绩</p>
                <p class="van-label">{{ amount.saleAchieveAmount }}</p>
              </el-col>
              <el-col class="cols" :span="4">
                <p class="van-text">总业绩</p>
                <p class="van-label">{{ amount.totalAchieveAmount }}</p>
              </el-col>
              <el-col class="cols" :span="4">
                <p class="van-text">劳动提成</p>
                <p class="van-label">{{ amount.workDeductAmount }}</p>
              </el-col>
              <el-col class="cols" :span="4">
                <p class="van-text">销售提成</p>
                <p class="van-label">{{ amount.saleDeductAmount }}</p>
              </el-col>
              <el-col class="cols" :span="4">
                <p class="van-text">总提成</p>
                <p class="van-label">{{ amount.totalDeductAmount }}</p>
              </el-col>
            </el-row>
          </div>
          <div class="boxs br10">
            <div class="align-items pr16" @click="lookList">
              <p class="order-title-boxs mtb20"><span class="blueBlock"></span><i>业绩明细</i></p>
              <p><i class="el-icon-arrow-down cur fontSize14 fb"></i></p>
            </div>
            <div class="plr16" v-if="listFlag">
              <el-table :data="list" :max-height="height - 460" header-cell-class-name="table_header_bgcolor">
                <el-table-column prop="itemName" label="服务名称"></el-table-column>
                <el-table-column prop="staffName" label="店员姓名"></el-table-column>
                <el-table-column prop="achieveAmount" label="业绩">
                  <template slot-scope="scope">
                    <p class="van-text" v-if="scope.row.achieveAmount >= 0">￥{{ scope.row.achieveAmount }}</p>
                    <p class="primary-color" style="color: #02c346;" v-else>￥{{ scope.row.achieveAmount }}</p>
                  </template>
                </el-table-column>
                <el-table-column prop="maxMoneyPreMonth" label="提成">
                  <template slot-scope="scope">
                    <p class="van-text" v-if="scope.row.achieveDeductAmount >= 0">￥{{ scope.row.achieveDeductAmount }}</p>
                    <p class="primary-color" style="color: #02c346;" v-else>￥{{ scope.row.achieveDeductAmount }}</p>
                  </template>
                </el-table-column>
                <el-table-column prop="oxCtime" label="创建时间" min-width="150px">
                  <template slot-scope="scope">{{ formatDate(scope.row.oxCtime) }}</template>
                </el-table-column>
              </el-table>
              <paging :currentPage="query.start" :totalCount="totalCount" @doPageQuery="doDataQuery"></paging>
            </div>
          </div>
        </div>
      </div>
      <edit-set ref="editForm" @change="refreshPage"></edit-set>
    </div>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import editSet from "./detail";
export default {
  mixins: [minxin],
  components: { editSet },
  data() {
    return {
      staffList: [],
      downloadUrl: require("../../../assets/images/home/data.png"),
      amount: {
        itemName: "",
        itemNum: "",
        saleAmount: "", //销售业绩
        saleDeductAmount: "",
        workAmount: "", //劳动
        workDeductAmount: ""
      },
      url: this.$url.integralAchievement.list,
      query: {
        staffId: "",
        beginTime: new Date(),
        endTime: new Date()
      },
      height: this.$store.getters.MainHeight,
      listFlag: false,
      isSuperManage: null
    };
  },

  created() {
    this.isSuperManage = this.$store.getters.ShopInfo.superManage;
    // if (this.isSuperManage) {
    //   this.query.staffId = ''
    // } else {
    // }
    this.query.staffId = this.$store.getters.ShopInfo.staffId
    this.companyStaffList();
  },
  mounted() {
    // this.init();
  },
  beforeDestroy() {
    if (this.$route.meta.title != "订单明细") {
      sessionStorage.removeItem("beginTime");
      sessionStorage.removeItem("endTime");
    }
  },
  methods: {
    refreshPage(org) {
      if (org) {
        this.getList();
      }
    },
    back() {
      this.$router.push('/dataList');
    },
    change(value) {
      this.query.start = 1;
      this.totalCount = 0;
      this.query.beginTime = value[0] ? this.formatDay(value[0]) : '';
      this.query.endTime = value[1] ? this.formatDay(value[1]) : '';
      this.listFlag = false;
      this.init();
    },
    selectChange(org) {
      this.query.staffId = org;
      this.query.start = 1;
      this.totalCount = 0;
      this.listFlag = false;
      this.init();
    },
    companyStaffList() {
      this.$api.post(this.$url.companyStaff.listAuthForData)
        .then(res => {
          this.staffList = res;
          // if (this.isSuperManage) {
          this.staffList.unshift({ id: '', staffName: '全部店员' })
          // }
        })
        .catch(error => { });
    },
    init(val) {
      this.$api.post(this.$url.integralAchievement.sumByShop, this.query)
        .then(res => {
          if (res) {
            this.amount = res;
          }
        });
    },
    totalCounts() {
      this.$api.post(this.$url.integralAchievement.count, this.query).then(res => {
        this.getData();
        this.totalCount = res;
      }).catch(error => { });
    },
    lookList() {
      // 查看列表
      if (!this.listFlag) {
        this.totalCounts();
        this.listFlag = true;
      }
    },
    detailPage(item) {
      this.$refs["editForm"].$emit("set", item.orderId);
    }
  }
};
</script>
<style scoped lang="less">
@import "../../../assets/css/edit.less";

* {
  box-sizing: border-box;
}

.page-head {
  height: 100%;
}
</style>